import { render, staticRenderFns } from "./step-three-banorte.vue?vue&type=template&id=496d089f&scoped=true"
import script from "./step-three-banorte.vue?vue&type=script&setup=true&lang=ts"
export * from "./step-three-banorte.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./step-three-banorte.vue?vue&type=style&index=0&id=496d089f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d089f",
  null
  
)

export default component.exports